// standard react component
import React from 'react';
import '../App.css';
import '../index.css';
import play from '../resources/play-solid.svg'
import { Draggable } from 'react-beautiful-dnd';
import {
    Bars3Icon,
  } from '@heroicons/react/24/outline'

const grid = 1;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid,
    margin: `0 0 ${grid}px 0`,
    fontWeight: "bold", 
    borderRadius: "0.375rem",
  
    // change background colour if dragging
    color: isDragging ? "white" : "black",
    background: isDragging ? "lightgreen" : "white",
  
    // styles we need to apply on draggables
    ...draggableStyle
  });
  

function MusicLogTableEntry(props) {
    console.log(props.logentry)

    const elipsis = (addElipsis) => {
        if (addElipsis) {
            return "...";
        } else {
            return "";
        }
    }

    const truncateText = (text, maxLength, addElipsis) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + elipsis(addElipsis);
        } else {
            return text;
        }
    }

    if (props.logentry.title === undefined) {
        return (
            <div className="mx-3 bg-yellow-500 rounded-md">
                <div className="grid grid-cols-3 gap-x-2 py-1">
                    <div className="px-3">
                        {/* total song count */}
                        <div>Total Songs: {props.logentry.count}</div>
                    </div>
                    <div className="px-2">
                        {/* upload date  */}
                        <div>{props.logentry.upload_date}</div>
                    </div>
                    <div className="px-2">
                        {/* output file */}
                        <div className="hidden sm:hidden md:block">{props.logentry.output_file}</div>
                    </div>
                </div>
            </div>
        ); 
    } else {
        return (
            <div className="mx-3 bg-emerald-500 rounded-md">
                <div className="grid grid-cols-3 gap-x-2 py-1">
                    <div className="px-3">
                        {/* id */}
                        <div>{props.logentry.id}</div>
                    </div>
                    <div className="px-2">
                        {/* title  */}
                        <div className="truncate">{truncateText(props.logentry.title, 30, true)}</div>
                    </div>
                    <div className="px-2">
                        {/* count */}
                        <div className="hidden sm:hidden md:block">{props.logentry.count}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MusicLogTableEntry;